export default {
  exclusions: [],
  params: {
    contact_id: null,
    warehouse_id: null,
    product_id: null,
  },
};



// WEBPACK FOOTER //
// ./src/b2b/modules/statistics-product-sale-client-exclusion/state.js